import { Spin, Typography } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BRAND_COLORS } from '../../../../../../constants/styles';
import { SectionLabel } from '../SectionLabel';

const { Text } = Typography;

export const HistoryChartContainer: FC<{
  loading: boolean;
  empty: boolean;
  title: string;
  historyDataCutoff?: string;
  children: React.ReactNode;
}> = ({ loading, empty, title, historyDataCutoff, children }) => {
  const { t } = useTranslation('dashboard.RecruiterDashboard.historyChart');
  return (
    <div>
      <SectionLabel>{title}</SectionLabel>
      <div
        style={{
          background: BRAND_COLORS.primary.royalBlue,
          border: `1px solid ${BRAND_COLORS.secondary.steelBlue}`,
          borderRadius: 8,
          padding: '16px 20px',
          minHeight: 180,
          position: 'relative',
        }}
      >
        {loading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(21, 101, 192, 0.7)',
              borderRadius: 8,
              zIndex: 1,
            }}
          >
            <Spin size="large" />
          </div>
        )}
        {!loading && empty && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 148,
            }}
          >
            <Text
              style={{ color: BRAND_COLORS.secondary.lightGray, fontSize: 12 }}
            >
              {t('noData')}
            </Text>
          </div>
        )}
        {!empty && children}
      </div>
      {historyDataCutoff && (
        <Text
          style={{
            color: BRAND_COLORS.secondary.lightGray,
            fontSize: 10,
            display: 'block',
            textAlign: 'center',
            marginTop: 8,
          }}
        >
          {t('cutoffNote', { date: historyDataCutoff })}
        </Text>
      )}
    </div>
  );
};
